import React, {useState} from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from '../../redux/actions/authActions';

import {
  Card,
  CardBody,
  Form,
  FormGroup,
  Label,
  Input,
} from "reactstrap";

import avatar from "../../assets/img/avatars/pvf_logo.jpg";

const SignIn = ({login, isAuthenticated}) => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const { email, password } = formData;

  const onChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value});

  const onSubmit = (e) => {
    e.preventDefault();
    console.log('hit')
    login(email, password);
  }

  // Redirect if logged in

  if(isAuthenticated) {
    return <Redirect to="/" />
  }

  return (
    <React.Fragment>
      <div className="text-center mt-4">
        <h2>Welcome back.</h2>
        <p className="lead">Sign in to your account to continue</p>
      </div>

      <Card>
        <CardBody>
          <div className="m-sm-4">
            <div className="text-center">
              <img
                src={avatar}
                alt="Pleasant Valley Farms"
                className="img-fluid rounded-circle"
                width="132"
                height="132"
              />
            </div>
            <Form onSubmit={e => onSubmit(e)}>
              <FormGroup>
                <Label>Email</Label>
                <Input
                  bsSize="lg"
                  type="email"
                  placeholder="Email Address"
                  name="email"
                  value={email}
                  onChange={e => onChange(e) }
                  required
                />
              </FormGroup>
              <FormGroup>
                <Label>Password</Label>
                <Input
                  bsSize="lg"
                  type="password"
                  placeholder="Password"
                  name="password"
                  value={password}
                  onChange={e => onChange(e) }
                />
              </FormGroup>
              <div className="text-center mt-3">
                <input type="submit" className="btn btn-primary" value="Sign In" />
              </div>
            </Form>
            <div className="text-center mt-3">
              <span>Dont have an account? <Link to="/auth/sign-up"><code>Sign Up</code></Link></span>
            </div>
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  );
}

SignIn.propTypes = {
  login: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps, { login })(SignIn);
